import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import classnames from 'classnames';
import grading from './../styles/grading.styl';

class QACollapseItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    render() {
        const { title, children, isError, titleCounters } = this.props;
        const { isOpen } = this.state;
        const arrowClassName = classnames(grading.arrow_down, { [grading.active]: isOpen });
        const className = classnames(grading.person_info_item, { [grading.is_error]: isError }, { [grading.active]: isOpen });
        return (
            <section className={className}>
                <div onClick={this.toggle}>
                    <h3>{title}</h3>
                    <span className={grading.cnt}>{titleCounters}</span>
                    <span className={arrowClassName}></span>
                </div>
                <Collapse isOpened={isOpen}>
                    {children}
                </Collapse>
            </section>
        );
    }
}

export default QACollapseItem;



// WEBPACK FOOTER //
// ./src/components/QACollapseItem.js